import { get, post } from "../utils/request";
import CryptData from "../utils/cryptData";

/**
 * 获取关于我们详情
 * @param {*} vm
 * @param {*} cb
 */
export const getAboutDetail = (vm, cb) => {
  post("/api/company/searchById")
    .then(res => {
      //console.log(res);
      if (res.code === 200) {
        vm.aboutObj = res.data || {};
        vm.aboutObj.imgUrl = vm.comImgUrl + vm.aboutObj.imgUrl;
        vm.aboutObj.serviceUrl = vm.comImgUrl + vm.aboutObj.serviceUrl;
        if (vm.computedYear) {
          vm.computedYear(res.data.establishDate);
        }
      }
      cb && cb(res);
      vm.$tips_msg(vm, res);
    })
    .catch(error => {
      vm.$tips_error(vm, error);
    });
};
